import React from 'react'

function SignOut() {
    return (
        <div>SignOut</div>
    )
}

export default SignOut